import _ from 'lodash';

import { SurveyAggregateQuestion } from './surveyAggregateQuestion';

export class SurveyAggregate {
  public formId: string;
  public formTitle: string;
  public sentOn: Date;
  public sent: number;
  public completed: number;
  public deadline: Date;
  public hasExpired: boolean;
  public aggregates: Array<SurveyAggregateQuestion> = new Array<SurveyAggregateQuestion>();

  static parse(data: any): SurveyAggregate {
    let agg = new SurveyAggregate();
    agg.formId = data.formId;
    agg.formTitle = data.formTitle;
    agg.sent = data.sent;
    agg.completed = data.completed;
    agg.deadline = data.deadline;
    agg.hasExpired = data.hasExpired;
    agg.sentOn = data.sentOn;
    agg.aggregates = _.map(data.aggregates, (a) => SurveyAggregateQuestion.parse(a));
    return agg;
  }
}
